export const downloadBlob = (blob: Blob, fileName: string) => {
  const objectUrl = URL.createObjectURL(blob);
  const downloadAnchor = document.createElement('a');

  downloadAnchor.href = objectUrl;
  downloadAnchor.download = fileName;
  downloadAnchor.style.display = 'none';

  document.body.appendChild(downloadAnchor);
  downloadAnchor.click();
  document.body.removeChild(downloadAnchor);

  URL.revokeObjectURL(objectUrl);
};
